export default __webpack_public_path__ + "static/media/principal.459b26a0.JPG";